import NextGen from './next-gen';

/**
 * Avif Class.
 */
class Avif extends NextGen {
	constructor() {
		super( 'avif' );
	}
}

( function() {
	'use strict';
	new Avif();
}() );
